import DisturbanceYberStatus from '@disturbance/DisturbanceYberStatus';
import * as React from 'react';
import { Affix } from 'telia-front-react/affix';
import { Button } from 'telia-front-react/button';
import { Card, CardContent } from 'telia-front-react/card';
import { Container } from 'telia-front-react/container';
import { Grid, GridColumn } from 'telia-front-react/grid';
import { Heading } from 'telia-front-react/heading';
import { Separator } from 'telia-front-react/separator';
import { Text } from 'telia-front-react/text';
import DisturbanceFilter from '@disturbance/DisturbanceFilter';
import DisturbanceFilterBar from '@disturbance/DisturbanceFilterBar';
import DisturbanceMap from '@disturbance/map/DisturbanceMap';
import DisturbanceTable from '@disturbance/DisturbanceTable';
import DisturbanceLocationModal from "@disturbance/DisturbanceLocationModal";

import { inject, observer } from 'mobx-react';

import TranslateStore from '@stores/TranslateStore';
import SsoStore from '@stores/SsoStore';
import ChangeDisturbanceStore from '@stores/ChangeDisturbanceStore';
import IncidentDisturbanceStore from '@stores/IncidentDisturbanceStore';
import FilterStore from '@stores/FilterStore';
import { DisturbanceType } from '@config/DisturbanceConfig';
import MenuStore from '@stores/MenuStore';
import config from '@config';

interface DisturbanceProps {
  isMobile: boolean;
  translateStore?: TranslateStore;
  changeDisturbanceStore?: ChangeDisturbanceStore;
  incidentDisturbanceStore?: IncidentDisturbanceStore;
  menuStore?: MenuStore;
  ssoStore?: SsoStore;
  filterStore?: FilterStore;
}

class DisturbanceClient extends React.Component<DisturbanceProps> {

  private disturbanceHeader(): JSX.Element {
    const {
      translateStore: { translate },
      menuStore,
      ssoStore
    } = this.props;

    return (
        <Text>
          <Grid align={['between-xs', 'middle-xs']} noWrap={['md']}>
            <GridColumn width={['xs', 'max-md']}>
              <Heading>{translate('general.title')}</Heading>
            </GridColumn>
            {ssoStore.loggedIn && ssoStore.customerId && (
                <GridColumn width={['xs', 'min-md']}>
                  <Button
                    text={translate('general.action.control.self')}
                    iconRight="#arrow-right"
                    type="primary"
                    size="small"
                    url={config.controlUrl}
                    target="_blank"
                  />
                </GridColumn>
            )}
          </Grid>
          <Grid>
            <GridColumn width={['max-xs']}>
              <DisturbanceYberStatus />
            </GridColumn>
          </Grid>
          <Grid>
            <GridColumn width={['xs', 'md-7']}>
              <Text>
                <p>
                  {translate('general.disturbance.info')}
                </p>
                {!ssoStore.loggedIn && (
                    <p>
                      {translate('general.disturbance.login')} <Button
                          text={translate('general.account.login')}
                          link={true}
                          onClick={(event) => {
                            event.preventDefault();
                            ssoStore.openSsoFrame();
                          }}
                      />.
                    </p>
                )}
              </Text>
            </GridColumn>
          </Grid>
        </Text>
    );
  }

  private disturbanceClient(): JSX.Element {
    const {
      isMobile,
      translateStore: { translate },
      filterStore: { filter },
      changeDisturbanceStore,
      incidentDisturbanceStore,
      ssoStore: { isDealer, customerId, hasIvrRole }
    } = this.props;

    return (
        <>
          <Heading element="h2" className="h3">{translate('disturbance.my')}</Heading>
          <Grid className="text__margin-double">
            <GridColumn width={['xs', 'md-7']}>
              <p>
                {translate('general.disturbance.client.info')}
              </p>
            </GridColumn>
          </Grid>
          <Grid reverse={['md']} className="text__margin-double">
            <GridColumn width={['xs-12', 'md-8', 'lg-9']}>
              <Text>
                {isMobile && <DisturbanceFilterBar isDealer={isDealer} customerId={customerId}/>}
                <Card>
                  <CardContent>
                    <DisturbanceTable
                        heading={translate('general.incidents')}
                        store={incidentDisturbanceStore}
                        rows={incidentDisturbanceStore.disturbances}
                        type={DisturbanceType.IncidentDisturbanceInfo}
                        employee={false}
                        isDealer={isDealer}
                        hasIvrRole={hasIvrRole}
                        filter={filter}
                        isLoading={incidentDisturbanceStore.isLoading}
                    />
                  </CardContent>
                </Card>
                <Card>
                  <CardContent>
                    <DisturbanceTable
                        heading={translate('general.changes')}
                        store={changeDisturbanceStore}
                        rows={changeDisturbanceStore.disturbances}
                        type={DisturbanceType.ChangeDisturbanceInfo}
                        employee={false}
                        filter={filter}
                        isDealer={isDealer}
                        hasIvrRole={hasIvrRole}
                        isLoading={changeDisturbanceStore.isLoading}
                    />
                  </CardContent>
                </Card>
              </Text>
            </GridColumn>
            <GridColumn width={['xs-12', 'md-4', 'lg-3']}>
              <Affix>
                <DisturbanceFilter isDealer={isDealer} customerId={customerId}/>
              </Affix>
            </GridColumn>
          </Grid>
          <DisturbanceLocationModal/>
        </>
    );
  }

  public render(): JSX.Element {
    const {
      translateStore: { translate },
      ssoStore: { auth, loggedIn, customerId, hasLegalMandate }
    } = this.props;

    return (
        <Container>
          <Text>
            {this.disturbanceHeader()}
            <Card className="text__margin-double">
              <CardContent>
                  <DisturbanceMap isOpen={!auth || loggedIn}/>
              </CardContent>
            </Card>
            {loggedIn && customerId && hasLegalMandate && (
                <>
                  <Separator color="invisible" spacing="xxsmall"/>
                  {this.disturbanceClient()}
                </>
            )}
          </Text>
        </Container>
    );
  }
}

export default inject(
  'isMobile',
  'translateStore',
  'menuStore',
  'ssoStore',
  'filterStore',
  'changeDisturbanceStore',
  'incidentDisturbanceStore',
)(observer(DisturbanceClient));
